exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".receiptEmailContainer {\r\n    display: flex;\r\n}\r\n.receiptEmailContainer input{\r\n}\r\n.receiptEmailContainer button{\r\n    min-width: 125px;\r\n    width: 175px;\r\n    padding: 0;\r\n    height: 33px;\r\n}\r\n\r\n@media(max-width: 575px){\r\n    .receiptEmailContainer button {\r\n        margin-top: 5px;\r\n    }\r\n}\r\n", ""]);

// exports
